import { GET_BLOGS } from '../actions'

export default function (state = {}, action) {
    switch (action.type) {
        case GET_BLOGS:
            return reverseObject(action.payload.data)
        default:
            return state
    }
}

function reverseObject(object) {
    var newObject = {};
    var keys = [];
    for (var key in object) {
        keys.push(key);
    }
    for (var i = keys.length - 1; i >= 0; i--) {

        var value = object[keys[i]];
        newObject[keys[i]] = value;
    }

    return newObject;
}


// WEBPACK FOOTER //
// ./src/reducers/blogsReducer.js